import { configure } from 'mobx'
import { storeMobx } from 'restaurant'
import { memberMobx, memberCardMobx, activityMobx, giftCardMobx, virtualOrderMobx, pointCardMobx, mktConfigMobx } from './mkt'
import { appMobx, decorationMobx, eatTypeStatusMobx, locationMobx, languageMobx, themeMobx, authConfigMobx } from './app'
import { payMobx, payPlanMobx, payChannelMobx, payRechargeMobx, tipMobx, bankCardMobx, surchargeMobx, thirdPartyMobx } from './pay'
import { advertMobx, boughtProductMobx, hotProductMobx, recommendMobx, switchMenuMobx, voiceServiceMobx } from './menu'
import { buyTogetherMobx, cartLiveMobx, checkoutMobx, deliveryMobx, multiPersonMobx, multiPersonOrderingMobx, posServiceMobx, queueOrderingMobx, preOrderingMobx, timePickMobx } from './cashier'
import { invoiceMobx, orderLiveMobx } from './order'
import * as localCache from './localCache'

// mobx配置
configure({
  enforceActions: 'always'
})

// rootMobx
const rootMobx = {
  storeMobx,
  // mkt
  memberMobx,
  memberCardMobx,
  activityMobx,
  giftCardMobx,
  virtualOrderMobx,
  pointCardMobx,
  mktConfigMobx,
  // app
  appMobx,
  decorationMobx,
  eatTypeStatusMobx,
  locationMobx,
  languageMobx,
  themeMobx,
  authConfigMobx,
  // pay
  payMobx,
  payPlanMobx,
  payChannelMobx,
  payRechargeMobx,
  surchargeMobx,
  tipMobx,
  bankCardMobx,
  timePickMobx,
  thirdPartyMobx,
  // menu
  advertMobx,
  boughtProductMobx,
  hotProductMobx,
  recommendMobx,
  switchMenuMobx,
  voiceServiceMobx,
  // cashier
  buyTogetherMobx,
  cartLiveMobx,
  checkoutMobx,
  deliveryMobx,
  multiPersonMobx,
  multiPersonOrderingMobx,
  posServiceMobx,
  queueOrderingMobx,
  preOrderingMobx,
  // order
  invoiceMobx,
  orderLiveMobx,
  // other
  localCache
}

// export
export {
  storeMobx,
  // mkt
  memberMobx,
  memberCardMobx,
  activityMobx,
  giftCardMobx,
  virtualOrderMobx,
  pointCardMobx,
  mktConfigMobx,
  // app
  appMobx,
  decorationMobx,
  eatTypeStatusMobx,
  locationMobx,
  languageMobx,
  themeMobx,
  authConfigMobx,
  // pay
  payMobx,
  payPlanMobx,
  payChannelMobx,
  payRechargeMobx,
  surchargeMobx,
  tipMobx,
  bankCardMobx,
  timePickMobx,
  thirdPartyMobx,
  // menu
  advertMobx,
  boughtProductMobx,
  hotProductMobx,
  recommendMobx,
  switchMenuMobx,
  voiceServiceMobx,
  // cashier
  buyTogetherMobx,
  cartLiveMobx,
  checkoutMobx,
  deliveryMobx,
  multiPersonMobx,
  multiPersonOrderingMobx,
  posServiceMobx,
  queueOrderingMobx,
  preOrderingMobx,
  // order
  invoiceMobx,
  orderLiveMobx,
  // other
  localCache
}

export default rootMobx
